/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import MailingAssetManager from "../../../components/BulkNotifications/MailingAssets";
import Navbar from "../../../components/Navbar";
import { backendUrlByEnv, LOGIN } from "../../../constants/routes";

const BulkNotificationsMailingAssets = () => {
  const navigate = useNavigate();
  const { config: userConfig, env } = useSelector((state) => state?.reducer?.authInfo) || {};
  const ROOT_URL = backendUrlByEnv(env);

  useEffect(() => {
    if (!userConfig?.bulkNotifications?.hasMailingAssetsAccess) {
      navigate(LOGIN);
    }
  }, []);

  return (
    <>
      <Navbar />
      <MailingAssetManager ROOT_URL={ROOT_URL} />
    </>
  );
};

export default BulkNotificationsMailingAssets;
